import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, Crosshair } from 'lucide-react';
import { NAV_LINKS } from '../mock';

const Logo = () => (
  <Link to="/" className="flex items-center gap-2 group" aria-label="Precision Analytics home">
    <span className="relative flex items-center justify-center w-9 h-9 rounded-full border border-[#e11d2a]/70 group-hover:border-[#e11d2a] transition-colors">
      <Crosshair className="w-5 h-5 text-[#e11d2a]" strokeWidth={1.5} />
    </span>
    <span className="font-display leading-none">
      <span className="block text-[#e11d2a] tracking-[0.22em] text-[15px] font-500">PRECISION</span>
      <span className="block text-white/90 tracking-[0.34em] text-[11px] font-300">ANALYTICS</span>
    </span>
  </Link>
);

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleAnchor = (e, to) => {
    if (to.startsWith('/#')) {
      e.preventDefault();
      const id = to.replace('/#', '');
      setOpen(false);
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 120);
      } else {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-[#060608]/90 backdrop-blur-md border-b border-white/5 py-3' : 'bg-transparent py-5'}`}>
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a key={l.label} href={l.to} onClick={(e) => handleAnchor(e, l.to)}
               className="text-[13px] tracking-wide text-white/70 hover:text-white transition-colors relative after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-[#e11d2a] hover:after:w-full after:transition-all after:duration-300">
              {l.label}
            </a>
          ))}
          <Link to="/contact"
            className="text-[13px] tracking-wide px-5 py-2 rounded-full bg-[#e11d2a] text-white hover:bg-[#c11624] transition-colors shadow-[0_0_20px_rgba(225,29,42,0.35)]">
            Contact
          </Link>
        </nav>
        <button className="md:hidden text-white" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-[#060608]/98 backdrop-blur-md border-t border-white/5 mt-3">
          <div className="px-6 py-4 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a key={l.label} href={l.to} onClick={(e) => handleAnchor(e, l.to)} className="text-white/80 text-sm tracking-wide">{l.label}</a>
            ))}
            <Link to="/contact" onClick={() => setOpen(false)} className="text-center text-sm px-5 py-2 rounded-full bg-[#e11d2a] text-white">Contact</Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
